// MP-OS-191 #13: the one English display label per Heart taxonomy value (Tobakssnus → Tobacco
// snus, Engångsvape → Disposable vape, Koffein → Caffeine …). displayLabels.json is an identical
// copy of app/api/data/display_labels.json, the map the API labels its responses with; tests on
// both sides keep the two equal. Display only: the value sent to the API stays the Heart value.
// An unmapped value is shown as Heart wrote it (never blank or guessed); the API logs it once.
import map from './displayLabels.json'

const BY_KEY: ReadonlyMap<string, string> = new Map(
  Object.entries(map.labels as Record<string, string>).map(([value, label]) => [value.trim().toLowerCase(), label]),
)

/** The English display label for a taxonomy value, or the value itself when unmapped. */
export function displayLabel(value: string): string {
  return BY_KEY.get(value.trim().toLowerCase()) ?? value
}

/** Whether the map has an English label for this value. */
export function hasDisplayLabel(value: string): boolean {
  return BY_KEY.has(value.trim().toLowerCase())
}

// Format does not apply to loose snus (the API drops it); the category is recognised through the
// map, so every spelling Heart uses for it (Lös, Lössnus) is covered.
const LOOSE_SNUS = 'Loose snus'
export function isLooseSnus(category: string): boolean {
  return displayLabel(category) === LOOSE_SNUS
}
